import React from 'react';
import Card from '../../common/Card/Card';
import { parseDateOnly, formatDeadline } from '../../../utils/competitionCards';
import styles from './OverviewSections.module.css';

/**
 * Competition Timeline: one card per stage, in stage order.
 *
 * The stage whose key matches `currentStageKey` carries a "Current" badge;
 * stages after it say "Unlocks if you advance". A stage with a placeholder name
 * or date is tagged so a stand-in is never mistaken for the real thing.
 * Renders nothing when there are no stages.
 */
const CompetitionTimeline = ({ stages, currentStageKey }) => {
  const ordered = [...(stages || [])].sort((a, b) => (a.number || 0) - (b.number || 0));
  if (!ordered.length) return null;

  const current = ordered.find((s) => s.key === currentStageKey) || null;

  return (
    <Card title="Competition Timeline">
      <div className={styles.timeline}>
        {ordered.map((stage) => {
          const isCurrent = current && stage.key === current.key;
          const locked = current && (stage.number || 0) > (current.number || 0);
          const date = parseDateOnly(stage.deadline?.date);
          const includes = (stage.includes || []).filter(Boolean);

          return (
            <div key={stage.key} className={`${styles.stage} ${isCurrent ? styles.stageCurrent : ''}`}>
              <div className={styles.stageTop}>
                <span className={styles.eyebrow}>Stage {stage.number}</span>
                {isCurrent && <span className={styles.currentBadge}>Current</span>}
                {locked && <span className={styles.unlockNote}>Unlocks if you advance</span>}
              </div>

              <h4 className={styles.stageName}>
                {stage.name}
                {stage.isPlaceholderName && <span className={styles.placeholderTag}>Placeholder</span>}
              </h4>

              {date ? (
                <div className={styles.stageDeadline}>
                  {formatDeadline(date)}
                  {stage.deadline?.isPlaceholder && <span className={styles.sampleTag}>Sample date</span>}
                </div>
              ) : (
                <div className={styles.stageDeadlineMissing}>Deadline not yet added</div>
              )}

              {stage.description && <p className={styles.stageDescription}>{stage.description}</p>}
              {includes.length > 0 && (
                <div className={styles.stageIncludes}>Includes: {includes.join(', ')}</div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default CompetitionTimeline;
